/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./okxWallet.vue?vue&type=template&id=f79addf0&scoped=true"
import script from "./okxWallet.vue?vue&type=script&lang=js"
export * from "./okxWallet.vue?vue&type=script&lang=js"
import style1 from "./okxWallet.vue?vue&type=style&index=1&id=f79addf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79addf0",
  null
  
)

export default component.exports